<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/1AKvXVq/images/9781952143854_cover.jpg?1708992466119" alt="This image is the cover for the book The Sea Flower"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">The Sea Flower
      </h1>
      <p class="bookDescription body article font2">
        <p>The Sea Flower (1964) centers on two down-and-out orphans, a persnickety cat, an eccentric fisherman, and the hurricane that brings them together. Marney Lessard and Liz Bigelow separately fled from trouble only to find themselves adrift on the same luxury houseboat. When they run aground on a nearly deserted Maine island, Arvid Small comes to their rescue. Stout and friendly, the island’s one seasonal resident attempts to change their fortunes with the help of some friends who are as genuine as the coastal Maine folk Ruth Moore knew herself.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Ruth Moore
      </h2>
      
      <p class="authorDescription body article">Born and raised in the Maine fishing village of Gotts Island, Ruth Moore (1903–1989) emerged as one of the most important Maine authors of the twentieth century, best known for her authentic portrayals of Maine people and her evocative descriptions of the state. She wrote thirteen novels throughout her lifetime, and was favorably compared to Faulkner, Steinbeck, Caldwell, and O’Connor. Moore and her partner, Eleanor Mayo, traveled extensively, but never again lived outside of Maine.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Islandport Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?5e78857b